"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var carol_1 = require("carol");
var iris_1 = require("iris");
var mapBooking_1 = require("./mapBooking");
var mapBookingResponse_1 = require("./mapBookingResponse");
var mapInitBookingRequest = function (input) {
    return {
        adults: input.adults,
        juveniles: input.juveniles,
        children: input.children,
        priceModel: input.priceModel,
    };
};
function importCruiseParameters(store, params) {
    store.commit("SET_CRUISE_PARAMETERS", params);
}
function fetchData(store, params) {
    return __awaiter(this, void 0, void 0, function () {
        var cruiseResponse, countriesResponse, formValidationsResponse, json, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    return [4 /*yield*/, iris_1.client.cruise(params.cruiseId, mapInitBookingRequest(params))];
                case 1:
                    cruiseResponse = _a.sent();
                    return [4 /*yield*/, iris_1.client.countries(true)];
                case 2:
                    countriesResponse = _a.sent();
                    return [4 /*yield*/, carol_1.client.i18n()];
                case 3:
                    formValidationsResponse = (_a.sent()).messages.de.bea
                        .validation;
                    json = mapBookingResponse_1.convertBookingResponse(cruiseResponse, countriesResponse, formValidationsResponse);
                    store.commit("SET_CRUISE_DATA", json);
                    store.commit("SET_STATIC_DATA", json);
                    store.commit("SET_SHIPS", cruiseResponse.ships);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    // maybe catch this during routing?
                    console.log("ajax error", error_1);
                    if (window &&
                        window.location &&
                        window.location.hostname === "www2.aida.de") {
                        window.location.href =
                            "https://www.aida.de/kreuzfahrt/angebote-buchen.18527.html";
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function isExpinetBookRequest(bookRequest) {
    if (!!bookRequest && typeof bookRequest.isExpinetOrigin === "boolean") {
        return bookRequest.isExpinetOrigin;
    }
    return false;
}
function book(store, params) {
    return __awaiter(this, void 0, void 0, function () {
        var oldBookRequest, json, externalBookRequest, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    store.commit("SET_BOOK_LOADER", true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    oldBookRequest = mapBooking_1.convertBookingRequest(params);
                    json = undefined;
                    if (!isExpinetBookRequest(params)) return [3 /*break*/, 3];
                    externalBookRequest = mapBooking_1.extendToExpinetBookRequest(oldBookRequest, params.agent);
                    return [4 /*yield*/, iris_1.client.book(externalBookRequest)];
                case 2:
                    json = _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, iris_1.client.book(oldBookRequest)];
                case 4:
                    json = _a.sent();
                    _a.label = 5;
                case 5:
                    if (json.errors && json.errors.length > 0) {
                        store.commit("SET_BOOK_ERROR", errorMessage(json.errors[0], params));
                    }
                    else if (json.bookingID) {
                        store.commit("SET_BOOK_NUMBER", json.bookingID);
                        store.commit("SET_BOOK_CONFIRMATION", params);
                    }
                    return [3 /*break*/, 7];
                case 6:
                    error_2 = _a.sent();
                    console.log("ajax book error: ", error_2);
                    store.commit("SET_BOOK_ERROR", error_2);
                    return [3 /*break*/, 7];
                case 7:
                    store.commit("SET_BOOK_LOADER", false);
                    return [2 /*return*/];
            }
        });
    });
}
// X9000001-001
function fetchFormPDF(_store, formId) {
    return __awaiter(this, void 0, void 0, function () {
        var requestInit, url, content;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestInit = {
                        headers: new Headers({
                            "x-api-key": "OJ0NBELhClaIPhsMuzJ4Y5us58V9Yspc8ugcAzwI",
                        }),
                        cache: "no-cache",
                        method: "GET",
                    };
                    url = "https://v70st8g8mi.execute-api.eu-central-1.amazonaws.com/test/requirement/" + formId + "/pdf";
                    content = null;
                    return [4 /*yield*/, fetch(url, requestInit)
                            .then(function (response) { return response.json(); })
                            .then(function (data) {
                            content = atob(data);
                        })
                        // console.log('content', content)
                    ];
                case 1:
                    _a.sent();
                    // console.log('content', content)
                    return [2 /*return*/, content];
            }
        });
    });
}
// export everything compliant to the vuex specification for actions
exports.default = {
    importCruiseParameters: importCruiseParameters,
    fetchData: fetchData,
    book: book,
    fetchFormPDF: fetchFormPDF,
};
function errorMessage(error, params) {
    switch (error.code) {
        case "3418":
            return {
                messages: [
                    {
                        header: "WICHTIGER HINWEIS",
                        level: "error",
                        message: 'Die Onlinebuchung ist zurzeit nicht möglich.<br /><br />\
                Bitte wenden Sie sich an unseren Verkaufsservice unter der \
                Telefonnummer: <a href=“tel:038120270777">0381 / 202 707 77.</a>',
                        type: "availability",
                    },
                ],
            };
        case "3500":
            return {
                messages: priceDifferMessages(error, params),
            };
        case "3501":
            return {
                messages: [
                    {
                        header: "ES TUT UNS LEID",
                        level: "warning",
                        message: 'Ihre gewählte Kabine ist nicht mehr verfügbar \
                <br><br>Bitte ändern Sie Ihre Auswahl oder kontaktieren Sie \
                unser AIDA Kundencenter unter \
                <a href=“tel:038120270722">0381 / 202 707 22</a>',
                        reference: "cabin",
                        type: "availability",
                    },
                ],
            };
        case "3504":
            return {
                messages: [
                    {
                        header: "ES TUT UNS LEID",
                        level: "warning",
                        message: "Ihr gewählter Flug ist nicht mehr verfügbar \
                <br><br>Bitte ändern Sie Ihre Auswahl oder kontaktieren Sie \
                unser AIDA Kundencenter unter \
                <a href=“tel:038120270722”>0381 / 202 707 22</a>",
                        reference: "flight",
                        type: "availability",
                    },
                ],
            };
        case "3505":
            return {
                messages: [
                    {
                        header: "WICHTIGER HINWEIS",
                        level: "warning",
                        message: 'Diese Reise kann nicht kostenfrei umgebucht werden.<br><br>Wenn Sie \
                dennoch verbindlich buchen möchten, klicken Sie bitte auf \
                "Buchung abschließen".',
                        reference: "optionBooking",
                        type: "confirmation",
                    },
                ],
            };
        case "3424":
            return {
                messages: [
                    {
                        header: "WICHTIGER HINWEIS",
                        level: "error",
                        message: "Aufgrund behördlicher Vorgaben darf leider nur eine \
                    begrenzte Anzahl ungeimpfter Gäste unter 12 Jahren mitreisen. <br /><br />\
                    Leider ist das Kontingent für diese Reise bereits erschöpft. <br /><br /> \
                    Bei Fragen kontaktieren Sie bitte unser AIDA Kundencenter unter <a href=“tel:038120270722”> +49 (0) 381 / 202 707 22.</a>",
                        type: "availability",
                    },
                ],
            };
        default:
            return {
                messages: [
                    {
                        header: "ES IST EIN FEHLER AUFGETRETEN",
                        level: "error",
                        message: "Wir bitten um Entschuldigung, denn es kam zu einem Fehler \
                in unserem System.<br><br>Bitte versuchen Sie es später noch \
                einmal oder kontaktieren Sie unser AIDA Kundencenter unter \
                <a href=“tel:038120270722”>0381 / 202 707 22</a>",
                        type: "availability",
                    },
                ],
            };
    }
}
function priceDifferMessages(error, params) {
    var errPriceDiffer = error.priceDiffer;
    var services = params.services;
    var messages = [];
    var priceDiffers = [];
    // console.log('services', services)
    //ugly code, but ... oh well -.-
    if (errPriceDiffer.cruises && errPriceDiffer.cruises.length > 0) {
        var services_1 = lodash_1.filter(params.services, ["type", "CRU"]);
        services_1.forEach(function (service) {
            var serviceIndex = lodash_1.findIndex(params.services, {
                type: "CRU",
                paxIds: service.paxIds,
            });
            var errService = lodash_1.find(errPriceDiffer.cruises, function (servicePrice) {
                return lodash_1.isEqual(servicePrice.paxIDs, service.paxIds);
            });
            var p2 = service.price;
            var prices = errService.price !== service.price
                ? { after: errService.price, before: service.price }
                : null;
            if (prices) {
                var priceDiffer = {
                    prices: prices,
                    service: serviceIndex,
                };
                priceDiffers.push(priceDiffer);
            }
        });
    }
    if (errPriceDiffer.flights && errPriceDiffer.flights.length > 0) {
        var services_2 = lodash_1.filter(params.services, ["type", "AIR"]);
        services_2 = lodash_1.uniqBy(services_2, "paxIds");
        services_2.forEach(function (service) {
            var airIndex = lodash_1.findIndex(params.services, {
                type: "AIR",
                paxIds: service.paxIds,
            });
            var errPrice = lodash_1.sumBy(lodash_1.filter(errPriceDiffer.flights, function (servicePrice) {
                return (lodash_1.find(servicePrice.paxIDs, function (paxID) {
                    return lodash_1.includes(service.paxIds, paxID);
                }) !== undefined);
            }), "price");
            var prices = Math.abs(lodash_1.subtract(service.price, errPrice)) > 1
                ? { after: errPrice, before: service.price }
                : null;
            if (prices) {
                var priceDiffer = {
                    prices: prices,
                    service: airIndex,
                };
                priceDiffers.push(priceDiffer);
            }
        });
    }
    if (errPriceDiffer.insurances && errPriceDiffer.insurances.length > 0) {
        var services_3 = lodash_1.filter(params.services, ["type", "INS"]);
        services_3.forEach(function (service) {
            var serviceIndex = lodash_1.findIndex(params.services, {
                type: "INS",
                paxIds: service.paxIds,
            });
            var errService = lodash_1.find(errPriceDiffer.insurances, function (servicePrice) {
                return lodash_1.isEqual(servicePrice.paxIDs, service.paxIds);
            });
            var prices = errService.price !== service.price
                ? { after: errService.price, before: service.price }
                : null;
            if (prices) {
                var priceDiffer = {
                    prices: prices,
                    service: serviceIndex,
                };
                priceDiffers.push(priceDiffer);
            }
        });
    }
    if (errPriceDiffer.trains && errPriceDiffer.trains.length > 0) {
        var services_4 = lodash_1.filter(params.services, ["type", "RIT"]);
        services_4.forEach(function (service) {
            var serviceIndex = lodash_1.findIndex(params.services, {
                type: "RIT",
                paxIds: service.paxIds,
            });
            var errService = lodash_1.find(errPriceDiffer.trains, function (servicePrice) {
                return lodash_1.isEqual(servicePrice.paxIDs, service.paxIds);
            });
            var prices = errService.price !== service.price
                ? { after: errService.price, before: service.price }
                : null;
            if (prices) {
                var priceDiffer = {
                    prices: prices,
                    service: serviceIndex,
                };
                priceDiffers.push(priceDiffer);
            }
        });
    }
    messages = lodash_1.map(priceDiffers, function (priceDiffer) {
        return {
            header: "IHR REISEPREIS HAT SICH GEÄNDERT",
            level: "warning",
            message: "Auf Grund einer technischen Aktualisierung hat \
            sich Ihr Reisepreis geändert.<br><br>Bitte bestätigen Sie \
            den neuen Reisepreis , um die Buchung abzuschließen.",
            price: priceDiffer.prices,
            reference: "price",
            service: priceDiffer.service,
            type: "confirmation",
        };
    });
    // console.log('messages', messages)
    return messages;
}
//# sourceMappingURL=actions.js.map